import { Phone, AlertTriangle } from "lucide-react";
import PrintPoster from "@/components/PrintPoster";
import { CARE_HOME_VISIT_URL } from "@/data/links";

const STEPS = [
  "Scan the QR code with a phone camera — a family member or neighbor can help.",
  "Tell us who needs the visit, where they live, and how we can help.",
  "Keep the reference number and PIN you receive to check on your request.",
];

const WHO = ["The sick & homebound", "Older parishioners", "Persons with disabilities", "Bereaved families"];

const Extra = () => (
  <div className="px-[24mm] mt-[6mm] space-y-[4mm]">
    <div className="flex flex-wrap justify-center gap-2">
      {WHO.map((w) => (
        <span key={w} className="border border-sage-dark/50 text-sage-dark rounded-full px-3 py-1 text-[9.5pt] font-sans">{w}</span>
      ))}
    </div>
    <div className="flex items-center justify-center gap-3 bg-cocoa-900 text-parchment-100 py-[3.5mm] px-[6mm]">
      <Phone size={18} className="text-gold" />
      <span className="font-sans text-[11pt]">No phone? Call the Parish Office</span>
      <span className="font-serif text-[16pt] text-gold">0915 581 1419</span>
    </div>
    <div className="flex items-start justify-center gap-2 text-[9pt] font-sans text-cocoa-700">
      <AlertTriangle size={13} className="mt-0.5 shrink-0 text-terracotta" />
      Not an emergency service. If someone is in danger or needs urgent medical help, call 911.
    </div>
  </div>
);

export default function CarePoster() {
  return (
    <PrintPoster
      testId="care-poster"
      docTitle="Mabuhay Care Home Visit Poster"
      kicker="Mabuhay Care · Home Visits"
      title={<>No one should feel <span className="italic text-terracotta">forgotten.</span></>}
      intro="Is someone in your family sick, elderly, or homebound? Request a home visit from the parish — for prayer, Holy Communion, comfort, or help."
      qrValue={CARE_HOME_VISIT_URL}
      urlLabel="pastoralcare.mabuhayparish.org"
      qrSize={190}
      steps={STEPS}
      footerNote="Every request is kept confidential · mabuhayparish.org"
    >
      <Extra />
    </PrintPoster>
  );
}
